<template>
  <div>
    <simple-wizard-ler v-if="sessionUserInfo.type == 'LO'">
      <!--
          <template slot="header">
            <h3 class="card-title">Build your profile</h3>
            <h3 class="description">
              This information will let us know more about you.
            </h3>
          </template>
    --->

      <wizard-tab
        :save-check="() => saveStep(step.name)"
        :before-change="() => validateStep(step.name)"
        v-for="step in wizardModel"
        :key="step.index"
      >
        <template slot="label">{{ step.title }}</template>

        <!-- 임대인 매물등록 -->
        <first-step
          v-if="step.name == 'step1'"
          ref="step1"
          @on-validated="onStepValidated"
        ></first-step>
        <second-step
          v-if="step.name == 'step2'"
          ref="step2"
          @on-validated="onStepValidated"
        ></second-step>
        <third-step
          v-if="step.name == 'step3'"
          ref="step3"
          @on-validated="onStepValidated"
        ></third-step>
        <fourth-step
          v-if="step.name == 'step4'"
          ref="step4"
          @on-validated="wizardComplete"
        ></fourth-step>
      </wizard-tab>
    </simple-wizard-ler>

    <simple-wizard-agt v-if="sessionUserInfo.type == 'AG'">
      <wizard-tab
        :save-check="() => saveStep(step.name)"
        :before-change="() => validateStep(step.name)"
        v-for="step in wizardModel"
        :key="step.index"
      >
        <template slot="label">{{ step.title }}</template>
        <!-- 공인중개사 매물등록 -->
        <agt-first-step
          v-if="step.name == 'AgtStep1'"
          ref="AgtStep1"
          @on-validated="onStepValidated"
        ></agt-first-step>

        <agt-second-step
          v-if="step.name == 'AgtStep2'"
          ref="AgtStep2"
          @on-validated="onStepValidated"
        ></agt-second-step>

        <agt-third-step
          v-if="step.name == 'AgtStep3'"
          ref="AgtStep3"
          @on-validated="wizardComplete"
        ></agt-third-step>
      </wizard-tab>
    </simple-wizard-agt>
  </div>
</template>
<script>
import FirstStep from "./wizard/ler_template/FirstStep.vue";
import SecondStep from "./wizard/ler_template/SecondStep.vue";
import ThirdStep from "./wizard/ler_template/ThirdStep.vue";
import FourthStep from "./wizard/ler_template/FourthStep.vue";

import AgtFirstStep from "./wizard/agt_template/AgtFirstStep.vue";
import AgtSecondStep from "./wizard/agt_template/AgtSecondStep.vue";
import AgtThirdStep from "./wizard/agt_template/AgtThirdStep.vue";

import Swal from "sweetalert2";
import { SimpleWizardAgt, SimpleWizardLer, WizardTab } from "@/components";

import { createNamespacedHelpers, mapGetters } from "vuex";
const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

import propApi from "@/service/property";
import filestoreApi from "@/service/filestore";

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    AgtFirstStep,
    AgtSecondStep,
    AgtThirdStep,
    SimpleWizardLer,
    SimpleWizardAgt,
    WizardTab
  },

  data() {
    return {
      wizardModel: {}
    };
  },

  created() {
    console.log("======stepCreated");

    if (this.sessionUserInfo.type == "AG") {
      this.wizardModel = {
        step1: {
          name: "AgtStep1",
          title: "이용 동의"
        },
        step2: {
          name: "AgtStep2",
          title: "전속중개계약서 등록"
        },
        step3: {
          name: "AgtStep3",
          title: "매물 정보 등록"
        }
      };
    } else {
      this.wizardModel = {
        step1: {
          name: "step1",
          title: "소유자 인증"
        },
        step2: {
          name: "step2",
          title: "이용동의"
        },
        step3: {
          name: "step3",
          title: "전속중개계약서"
        },
        step4: {
          name: "step4",
          title: "매물등록"
        }
      };
    }
  },

  mounted() {},

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry",
      sessionUserInfo: "getUserInfo"
    })
  },
  methods: {
    ...sessionMapActions(["clearPropertyInquiry"]),

    saveStep(ref) {
      return this.$refs[ref][0].saveStep();
    },
    validateStep(ref) {
      return this.$refs[ref][0].validate();
    },
    onStepValidated(validated, model) {
      // this.wizardModel = { ...this.wizardModel, ...model };
    },

    async uploadFile(value) {
      console.log("파일업로드");
      // if (value.fileList.length < 1) {
      //   Message.warning("파일을 등록해주세요.");
      //   return;
      // }

      // if (
      //   value.fileList.length &&
      //   value.fileList
      //     .map(file => file.size)
      //     .reduce((acc, curr) => acc + curr) >
      //     100 * 1000 * 1000
      // ) {
      //   Message.warning("파일 전체 크키는 100MB를 초과할 수 없습니다.");
      //   return;
      // }

      if (value.fileList.length > 0) {
        let formData = new FormData();
        value.fileList.forEach(file => formData.append("files", file.raw)); // append raw file info

        const res = await filestoreApi.uploadMultipleFiles(formData); // 다중파일 업로드
        console.log("파일업로드 성공??");
        console.log(res);

        value.idArr = [];
        res.payload.forEach(fileItem => value.idArr.push(fileItem.id));
      }
      if (value.removedIdArr.length > 0) {
        for (let i = 0; i < value.removedIdArr.length; i++) {
          let removalId = value.removedIdArr[i];
          const deleteRes = await filestoreApi.deleteFile(removalId); // 파일삭제API 호출
          if (deleteRes.status === 200) {
            // 삭제성공 시, 삭제된 파일들의 id정보를 저장 -> Notice테이블의 파일참조Id에서 삭제
            value.idArr.splice(value.idArr.indexOf(removalId), 1);
          }
        }
      }

      // 매물 관련 업로드 file id list 이용
      //this.G_Img_File.idArr.toString()
    },

    async wizardComplete() {
      /*
      const postData = {
        certification: {
          legalCode: "1168010600",
        },
        contractInfo: {
          buildYear: "2019-10-10",
        },
        propertyInfo: {
          jpvTypeCd: 10, // 원룸
          supplyArea: 50.33,
          useArea: 40.22,
          totalFloor: 15,
          thisFloor: 10,
          heatingType: 19, // 개인난방
          heatingFuel: 58, // 도시가스
          fullJAddr:
            "서울특별시 도봉구 방학동 720-1 대상타운현대아파트 103동 1902호", // 지번
          fullRAddr:
            "서울특별시 도봉구 마들로 616(방학동, 대상타운현대아파트) 103동 1902호", // 도로명
          TNOParking: 3, // 주차가능 대수
          isElevator: true, // 엘레베이터 유무
          isLoan: true, // 대출가능
          TNORooms: 3, // 방개수
          TNOBathRoom: 2, // 욕실수
          deposit: 1000000, // 보증금
          monthlyPay: 200000, // 월세
          entStructure: 55, // 계단식
          TNOHousehold: 200, // 세대수
          contractType: 25,
          optionList: [23, 24], // 냉장고, 세탁기
        },
      };
*/

      // 상태(state)
      let state = null;

      if (this.sessionUserInfo.type == "AG") {
        state = "CHS";
      } else if (this.sessionUserInfo.type == "LO") {
        state = "RQ";
      }

      // 일반 사진 업로드
      let upldFileList = null;

      if (
        this.sessionPropertyInquiry.propertyInfo.G_Img_File.fileList.length > 0
      ) {
        await this.uploadFile(
          this.sessionPropertyInquiry.propertyInfo.G_Img_File
        );

        upldFileList = this.sessionPropertyInquiry.propertyInfo.G_Img_File
          .idArr;
      }

      // VR 사진 업로드
      // let vrUpldFileList = null;

      // if (
      //   this.sessionPropertyInquiry.propertyInfo.G_Img_File.fileList.length > 0
      // ) {
      //   await this.uploadFile(
      //     this.sessionPropertyInquiry.propertyInfo.Vr_Img_File
      //   );
      //   vrUpldFileList = this.sessionPropertyInquiry.propertyInfo.Vr_Img_File
      //     .idArr;
      // }

      // 공인중개사는 contSaveDTO 없음
      let contSaveDTO = null;
      if (this.sessionUserInfo.type == "AG") {
        contSaveDTO = null;
      } else {
        contSaveDTO = {
          type: this.sessionPropertyInquiry.contractInfo.type, // 임대, 임차 ... code from coCode
          expireDate: this.sessionPropertyInquiry.contractInfo.contrValUTC, // 계약 만기일 2020-08-01 10:10:10(UTC)
          paymentType: this.sessionPropertyInquiry.contractInfo.paymentType, // 전세, 월세 code from coCode
          deposit: this.sessionPropertyInquiry.contractInfo.deposit, // 보증금
          etc: this.sessionPropertyInquiry.contractInfo.etc, // 기타사항
          regulation: this.sessionPropertyInquiry.contractInfo.regulation, // 거래규제 및 공법상 제한사항
          relation: this.sessionPropertyInquiry.contractInfo.rightRel, // 권리관계
          extraFee: this.sessionPropertyInquiry.contractInfo.otherFee, // 은행융자, 권리금, 제세공과금 등(또는 월임대료, 보증금, 관리비 등)
          clientContactNum: this.sessionPropertyInquiry.contractInfo.clientTel, // 중개의뢰인 연락처
          clientBirthDate: this.sessionPropertyInquiry.contractInfo.clientBirth, // 중개의뢰인 생년월일 19891111
          clientName: this.sessionPropertyInquiry.contractInfo.clientName, // 중개의뢰인 이름
          clientAddr: this.sessionPropertyInquiry.contractInfo.clientAddr, // 중개의뢰인 주소
          brokePrice: this.sessionPropertyInquiry.contractInfo.brokCompenPrice, // 중개보수
          brokeRate: this.sessionPropertyInquiry.contractInfo.brokCompenRate, // 중개보수율
          provInfoYn: this.sessionPropertyInquiry.contractInfo.provideData, // 매물정보 공개동의 유무
          payment: this.sessionPropertyInquiry.contractInfo.monthlyPay //월세
        };
      }

      // 백엔드로 보낼 데이터 담기
      const postData = {
        contractSaveDTO: contSaveDTO,
        // 매물 정보
        userPrimaryKey: this.sessionUserInfo.primaryKey,
        state: state, // 매물상태
        type: this.sessionPropertyInquiry.propertyInfo.jpvTypeCd, // 원룸, 빌라, 주택, 원룸 (집비오분류)
        proArea: this.sessionPropertyInquiry.propertyInfo.provArea, // 공급면적
        useArea: this.sessionPropertyInquiry.propertyInfo.useArea, // 전용면적
        story: this.sessionPropertyInquiry.propertyInfo.grndFlrCnt, // 건물 높이(층)
        floor: this.sessionPropertyInquiry.propertyInfo.flrJustNum, // 매물 층

        heatingType: this.sessionPropertyInquiry.propertyInfo.heatingType, // 개별난방, 중앙난방, 지역난방
        heatingFuelType: this.sessionPropertyInquiry.propertyInfo.heatingFuel, // 난방연료 종류

        addr: this.sessionPropertyInquiry.propertyInfo.propertyJAddr, // 지번 주소
        newAddr: this.sessionPropertyInquiry.propertyInfo.propertyRAddr, // 도로명 주소

        faParkingCnt: this.sessionPropertyInquiry.propertyInfo.PknPerFmly,
        parkingCnt: this.sessionPropertyInquiry.propertyInfo.totPkngCnt, //주차 가능대수

        eleYn: this.sessionPropertyInquiry.propertyInfo.eleYn, // 엘레베이트 유무
        verandaYn: this.sessionPropertyInquiry.propertyInfo.verandaYn, // 베란다 존재 유무
        balconyYn: this.sessionPropertyInquiry.propertyInfo.balconyYn, // 발코니 존재 유무
        loanYn: this.sessionPropertyInquiry.propertyInfo.loanYn, // 전세대출 가능 유무
        roomCnt: this.sessionPropertyInquiry.propertyInfo.TNORooms, //방개수
        wroomCnt: this.sessionPropertyInquiry.propertyInfo.TNOBathRooms, //욕실수
        legalCode: this.sessionPropertyInquiry.propertyInfo.locationInfo.admCd, //법정동코드
        entType: this.sessionPropertyInquiry.propertyInfo.entStructure, //현관구조
        householdCnt: this.sessionPropertyInquiry.propertyInfo.hhldCnt, //세대수
        platArea: this.sessionPropertyInquiry.propertyInfo.platArea, // 대지면적
        totArea: this.sessionPropertyInquiry.propertyInfo.totArea, // 연면적
        purp: this.sessionPropertyInquiry.propertyInfo.purps, //  용도(건축법)
        useAprDay: this.sessionPropertyInquiry.propertyInfo.permitDate, // 사용승인일
        // 건축물 정보
        districtPurpList: this.sessionPropertyInquiry.propertyInfo.rawBrdList, // 용도지역
        moveDt: this.sessionPropertyInquiry.propertyInfo.possibleMoveDate, // 입주가능일
        dong: this.sessionPropertyInquiry.propertyInfo.dongJustNm, //동 (뒤에 '동' 제외)
        ho: this.sessionPropertyInquiry.propertyInfo.hoJustNm, //호 (뒤에 '호' 제외)
        mtncFee: this.sessionPropertyInquiry.propertyInfo.maintenanceFee, // 관리비
        builtinOptCdList: this.sessionPropertyInquiry.propertyInfo.optionList, //빌트인 옵션 리스트
        mtncCdList: this.sessionPropertyInquiry.propertyInfo.maintenList, //관리비 포함항목
        useCdList: this.sessionPropertyInquiry.propertyInfo.useFeeList, // 사용료 포함항목
        securityOptCdList: this.sessionPropertyInquiry.propertyInfo
          .securityList, // 보안시설 리스트
        lat: this.sessionPropertyInquiry.propertyInfo.propertyLat, // 위도
        lng: this.sessionPropertyInquiry.propertyInfo.propertyLong, // 경도
        deposit: this.sessionPropertyInquiry.propertyInfo.deposit, //보증금
        payment: this.sessionPropertyInquiry.propertyInfo.monthlyPay, //월세
        paymentType: this.sessionPropertyInquiry.propertyInfo.paymentType, // 전세, 월세
        strct: this.sessionPropertyInquiry.propertyInfo.strct, // 구조
        name: this.sessionPropertyInquiry.propertyInfo.bdNm, //건축물 명
        mainPurp: this.sessionPropertyInquiry.propertyInfo.purpsDetail, //세부용도(주용도)(api)
        direction: this.sessionPropertyInquiry.propertyInfo.direction, //방향
        directionCri: this.sessionPropertyInquiry.propertyInfo.directionStd, //방향 기준
        //vrUpldFileList: vrUpldFileList, // vr list
        //thUpldFileList: this.sessionPropertyInquiry.propertyInfo.th_Img_File.idArr, // 열화상 list
        upldFileList: upldFileList, // 일반사진 list

        jiBun: this.sessionPropertyInquiry.propertyInfo.jiBun, // 지번주소의 지번
        legalDong: this.sessionPropertyInquiry.propertyInfo.legalDong, // 법정동
        petYn: this.sessionPropertyInquiry.propertyInfo.petYn, //반려동물 가능 여부
        showHouseInfoYn: this.sessionPropertyInquiry.propertyInfo.oneHouseAgr, // 추가정보 동의 YN (단독주택 경우)
        showShareHouseInfoYn: this.sessionPropertyInquiry.propertyInfo
          .shareHouseAgr, // 추가정보 동의 YN (공동주택 경우)
        comment: this.sessionPropertyInquiry.propertyInfo.etcComment //기타 의견
      };

      console.log("=====1");
      console.log(postData);
      console.log("=====2");
      console.log(this.sessionPropertyInquiry);
      const res = await propApi.saveProperty(postData);
      console.log(res);

      // this.clearPropertyInquiry();

      Swal.fire({
        title: "Good job!",
        text: "You clicked the finish button!",
        type: "success",
        confirmButtonClass: "btn btn-success",
        buttonsStyling: false
      });
    }
  }
};
</script>
